import _ from "lodash";

export type Status = "succeeded" | "failed" | "in_progress" | "pending" | "canceled";

export const statuses: Status[] = [
  "succeeded",
  "failed",
  "in_progress",
  "pending",
  "canceled",
];

export type OperationType = "renewal" | "dunning";

export const operationTypes: OperationType[] = [
  "renewal",
  "dunning",
];


export type ErrorCode = "payment_failed" | "unknown_error";

export const errorCodes: ErrorCode[] = [
  "payment_failed",
  "unknown_error",
];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const selectErrorCodes = errorCodes.map((errorCode) => {
  return { value: errorCode, label: errorCode.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  succeeded: "green",
  failed: "red",
  in_progress: "orange",
  pending: "gray",
  canceled: "yellow",
};

export const colorsByOperationType: Record<OperationType, string> = {
  renewal: "blue",
  dunning: "orange",
};

export const colorsByErrorCode: Record<ErrorCode, string> = {
  payment_failed: "violet",
  unknown_error: "gray",
};
